import { render } from "./SelectTriggers.vue?vue&type=template&id=5e81b98d&scoped=true"
import script from "./SelectTriggers.vue?vue&type=script&lang=js"
export * from "./SelectTriggers.vue?vue&type=script&lang=js"

import "./SelectTriggers.vue?vue&type=style&index=0&id=5e81b98d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e81b98d"]])

export default __exports__